module.exports = {"src":72,"persistentEndpoint":"editor-performance","nonPersistentEndpoint":"editor-performance","successRateRoot":"editor_events","performanceRoot":"editor_performance","appLoadStart":{"eventId":41},"appLoadFinish":{"eventId":43},"interactionStart":{"eventId":44},"interactionEnd":{"eventId":45},"loadPhaseStart":{"eventId":48},"loadPhaseFinish":{"eventId":42},"error":{"eventId":46},"resource":{"eventId":47}}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/fedops-presets/dist/es/presets/editor.json
// module id = 231
// module chunks = 0 1